<template>
  <div>
    <SiteDetail v-if="this.visible" :visible.sync="visible" :site="siteDetailData" />
  </div>
</template>

<script>
import Utils from "../../../config/utils";
import SiteDetail from "./interest/SiteDetail";

export default {
  name: "ShareSite",
  components: {SiteDetail},
  data() {
    return {
      visible: false,
      siteDetailData: {},
      site_idx: this.$route.params.site_idx,
    }
  },
  mounted() {
    this.getSiteDetail();
  },
  methods: {
    getSiteDetail() {
      Utils.requestGet(
        this.$c.API.Site.getSiteDetail,
        {
          site_idx: this.site_idx,
          skip_log_recent_view: true,
        },
      ).then(result => {
        if (result.code == this.$c.API_RES_CODE.SUCCESS) {
          this.siteDetailData = result.data;
          this.visible = true;
          console.log(this.siteDetailData);
          if (result.data.isHidden) {
            Utils.toast(this, this.$t('common.deleted_hidden_site'));
          }
        } else {
          Utils.toast(this, result.msg);
        }
      });
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/contents/main/ShareSite.vue